const mode = (process.env.REACT_APP_ENVIRONMENT || 'staging').trim().toLowerCase();
const isStaging = mode === 'staging';

const cfg = {
  environment: mode,
  apiBase: process.env.REACT_APP_API_BASE_URL || '',
  priceFree: isStaging ? process.env.REACT_APP_PRICE_FREE_MONTHLY_TEST : process.env.REACT_APP_PRICE_FREE_MONTHLY_LIVE,
  pricePro: isStaging ? process.env.REACT_APP_PRICE_PRO_MONTHLY_TEST : process.env.REACT_APP_PRICE_PRO_MONTHLY_LIVE,
  priceEnterprise: isStaging ? process.env.REACT_APP_PRICE_ENTERPRISE_MONTHLY_TEST : process.env.REACT_APP_PRICE_ENTERPRISE_MONTHLY_LIVE,
  successUrl: (origin) => `${origin}/billing/success`,
  cancelUrl: (origin) => `${origin}/billing/cancel`,
};

export default cfg;
